import React, { useEffect, useState } from "react";
import { Navbar, TaskCard, EventCalendar } from "../components/indexComponents";
import "../CSS/Profile.css";

function Profile() {
  const [personnalTask, setPersonnalTask] = useState([""]);
  const [teamTask, setTeamTask] = useState([""]);
  const [personnalClients, setPersonnalClients] = useState([""]);
  const [teamClients, setTeamClients] = useState([""]);
  const [isLoading, setIsLoading] = useState(true);
  const [hideDone, setHideDone] = useState(false);

  const getAllTasks = async () => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/all-tasks`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch task");
    }

    const data = await response.json();
    const personalTasks = data.filter((task) => !task.teamId);
    setPersonnalTask([...personalTasks]);
    const teamTasks = data.filter((task) => task.teamId);
    setTeamTask([...teamTasks]);

    const personalClients = personalTasks.map((task) => task.Client);
    setPersonnalClients(personalClients);
    const teamClients = teamTasks.map((task) => task.Team_Client);
    setTeamClients(teamClients);
    setIsLoading(false);
  };
  useEffect(() => {
    getAllTasks();
  }, []);

  return (
    <div className="page-frame">
      <Navbar />
      <div className="page-content profile-content">
        {!isLoading ? (
          <>
            <h1>Profile</h1>
            <div className="calendar">
              <h2 className="h2">Calendrier</h2>
              <EventCalendar isTeam={false} />
            </div>
            <h2 className="all-tasks-title">Vos tâches actives </h2>
            <p className="profile-desc">
              Ici vous trouverez tous les tâches qui vous concerne incluant
              celle de vos équipes.
            </p>
            <button
              onClick={() => {
                setHideDone(!hideDone);
              }}
            >
              Cacher les tâches terminées
            </button>
            <div className="task-container">
              {personnalTask ? (
                <>
                  {personnalTask.map((task, index) => (
                    <div key={index} className="w-100-600px">
                      {hideDone ? (
                        <>
                          {task.statue === "Terminé" ? (
                            ""
                          ) : (
                            <div key={index} className="card">
                              <TaskCard
                                task={task}
                                refreshTasks={getAllTasks}
                                isTeam={false}
                                clients={personnalClients}
                              />
                            </div>
                          )}
                        </>
                      ) : (
                        <div key={index} className="card">
                          <TaskCard
                            task={task}
                            refreshTasks={getAllTasks}
                            isTeam={false}
                            clients={personnalClients}
                          />
                        </div>
                      )}
                    </div>
                  ))}
                </>
              ) : (
                ""
              )}

              {teamTask ? (
                <>
                  {teamTask.map((task, index) => (
                    <div key={index} className="w-100-600px">
                      {hideDone ? (
                        <>
                          {task.statue === "Terminé" ? (
                            ""
                          ) : (
                            <div key={index} className="card">
                              <TaskCard
                                task={task}
                                refreshTasks={getAllTasks}
                                isTeam={true}
                                clients={teamClients}
                              />
                            </div>
                          )}
                        </>
                      ) : (
                        <div key={index} className="card">
                          <TaskCard
                            task={task}
                            refreshTasks={getAllTasks}
                            isTeam={true}
                            clients={teamClients}
                          />
                        </div>
                      )}
                    </div>
                  ))}
                </>
              ) : (
                ""
              )}
            </div>
          </>
        ) : (
          <>
            <div>
              <h1>Chargement du profile...</h1>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Profile;
